var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seat-container"},[_c('div',{staticClass:"seat-id is-inline-block is-size-7"},[_vm._v("   ")])])}]

export { render, staticRenderFns }